import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OCAPI_HTTP_HEADER } from '../core/config/http-header.config';
import { SettingsService } from '../core/services/settings/settings.service';
import { UrlPart } from '../utils/global-constants';

@Injectable()
export class OcapiApiHeaderInjectionInterceptor implements HttpInterceptor {
  public constructor(private readonly settingsService: SettingsService) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.url.includes(UrlPart.Calculations)) {
      let headers: Record<string, string> = {};

      if (this.settingsService.data.apis.ocapi.apiKey) {
        headers = { ...headers, [OCAPI_HTTP_HEADER.API_KEY]: this.settingsService.data.apis.ocapi.apiKey };
      }

      const clone = req.clone({
        setHeaders: headers
      });

      return next.handle(clone);
    }
    return next.handle(req);
  }
}
